import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/atUWghtyzcsrXcnkCqoNbq/Mockup_-_SN19.webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-66" data-mp="4lyvmmybwge6">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-67" data-mp="1297cu5rar3ad" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-68" data-mp="xae74zi94gkr">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-69" data-mp="xb5slhi4wxxb">
          🌿 BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto mt-5 max-w-5xl font-display text-[19px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-70" data-mp="3d2lapfhgtb2a">
          Reducí la hinchazón abdominal en 7 días{' '}
          <span className="text-brand-light" data-id="element-71" data-mp="3o73no75q7m5y">
            con un sistema simple de alimentación y hábitos, sin dietas extremas.
          </span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-72" data-mp="3e8wi0kgw0qj9">
          <img src={mockupUrl} alt="Mockup del Protocolo Abdomen Liviano" width="1244" height="1244" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-73" data-mp="359syjfdt6948" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-74" data-mp="2hjox9eo3elge">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-75" data-mp="s3mcg0c5huxb">
            PROTOCOLO ABDOMEN LIVIANO™
          </p>
          <p className="-mb-4 mt-3 text-[13px] text-slate-200 sm:text-base" data-id="element-76" data-mp="iboyiltrcouw">
            Un protocolo práctico de 5 volúmenes para mujeres argentinas que quieren sentirse más livianas, ordenadas y cómodas con su digestión.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-77" data-mp="1b0drfxkntnvk">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="15zq17e499b2e">
              <FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-79" data-mp="x14npxdn4m8h" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-80" data-mp="3lsp3vew9yley">
              <ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-81" data-mp="3hr3ptq808136" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-82" data-mp="1x7853o1s1ru4">
          <ActionButton href="#pricing" showTrust data-id="element-83" data-mp="2686aoarv67et">
            🌿 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}